import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { PresentationStyles } from '@wg/wows-entities/const';
import WoWSEntity from '@wg/wows-entities/wrappers/react/WoWSEntity';
import styles from './QuantityText.scss';
import { thousands } from '~/utils/formatting';
import { CURRENCIES } from '~/constants';

interface IQuantityComponent {
    amount: number,
    type: string,
    isShort?: boolean,
    label?: string,
    withoutIcon?: boolean,
}

const QuantityText = (props: IQuantityComponent) => {
    const { t } = useTranslation();

    const getAmountText = () => {
        switch (props.type) {
            case CURRENCIES.CREDITS:
            case CURRENCIES.STEEL:
            case CURRENCIES.FREE_XP:
            case CURRENCIES.ELITE_XP:
            case CURRENCIES.COAL:
            case CURRENCIES.PARAGON_XP:
                return (
                    <WoWSEntity
                        type={props.type}
                        amount={props.amount}
                        presentation={{
                            withTooltip: false,
                            style: PresentationStyles.TTC,
                        }}
                    />
                );
            default:
                return thousands(props.amount);
        }
    };

    return (
        <React.Fragment>
            {!props.isShort && (
                <div className={styles.contentBlockSmallTitle}>
                    {props.label ?? t('Количество: ')}
{' '}
{getAmountText()}
                </div>
            )}
        </React.Fragment>
    );
};

export default QuantityText;
